import { createRoutine } from 'redux-saga-routines'

export const SET = 'CONTACT/SET'
export const RESET = 'CONTACT/RESET'
export const SUBMIT = createRoutine('CONTACT/SUBMIT')
